module.exports = __webpack_public_path__ + "static/media/doctors-portal.765beb67.png";